import React, { useContext, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import { MacSsoVerifyUserPayloadModel } from '../../models/axiosModels';
import agent from '../../Services/api';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';

const SsoHome = () => {
  const {
    userProfileDetails,
    setUserProfileDetails,
    registerUserProfileDetails,
    setRegisterUserProfileDetails,
    userDetails,
    setFlagLoader,
    getUserAppWithStatus
  } = useContext(GlobalUserContext) as GlobalUserContextPayload;

  const {
    setDashboardDetails
  } = useContext(DashboardContext) as DashboardDetailPayload

  const { showSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const verifyToken = searchParams.get('token');

    if (verifyToken) {
      setFlagLoader(true)

      const verifyUser = async () => {
        const payload: MacSsoVerifyUserPayloadModel = { token: verifyToken, flag: false }
        const response = await agent.macssoVerifyUserApi.post(payload)
        if (response?.status) {
          setFlagLoader(false)

          if (response?.data?.isUserExist) {
            navigate("/dashboard")
            await initializeAuth()
          }
          else {
            const userDetails = response?.data?.user;
            setRegisterUserProfileDetails({
              ...registerUserProfileDetails,
              email: userDetails.email,
              firstName: userDetails.firstName,
              lastName: userDetails.lastName,
              contact: userDetails.phone ?? "",
              agencyName: userDetails.agencyName ?? "",
              flagUserExist: true,

            })
            navigate(`/register?token=${verifyToken}`)

          }
        }
        else {
          const err = response?.error?.message;
          showSnackbar(err, 'error')
          setUserProfileDetails({
            ...userProfileDetails,
            flagLoggedIn: false,
          });
          navigate("/")
          setFlagLoader(false)
        }
      }
      verifyUser()
    }
    else {
      navigate("/")
    }
  }, [])

  const initializeAuth = async () => {
    try {
      setFlagLoader(true);
      const response = await userDetails();
      if (response?.status && response?.data) {
        const userMeResponse = response.data
        setUserProfileDetails({
          ...userProfileDetails,
          flagLoggedIn: true,
          user: response.data.user,
          accessToken: response.data.accessToken,
          // apps: response.data.apps
        });
        // if (userMeResponse.apps) {
        //   setDashboardDetails({ apps: userMeResponse.apps });
        // }
        await fetchApps()
        setFlagLoader(false);
      }
      else {
        navigate('/');
        setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
        setFlagLoader(false);
      }
    } catch (error) {
      console.error('Auth initialization error:', error);
      setUserProfileDetails(prevState => ({ ...prevState, flagLoggedIn: false }));
      navigate('/');
      setFlagLoader(false);
    }
  };

  const fetchApps = async () => {
    const response = await getUserAppWithStatus();
    if (response?.status) {
      const responseData = response?.data
      if (responseData?.apps) {
        setDashboardDetails({ apps: responseData.apps });
      }
    }
    else {
      setFlagLoader(false);
      const error = response?.data?.error?.message ? response?.data?.error?.message : "Something Went Wrong!";
      showSnackbar(error, "error")
    }
  }


  return (
    <div></div>
  )
}

export default SsoHome
